import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { heightExpansion } from '@vsolv/vectors-ui/animations';
import { NavItem } from '../nav-item';

export interface SideBarNavItem extends NavItem {
  hideDetailArrow?: boolean;
  showDefaultIcon?: boolean;
  href?: string;
}

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'vs-sidebar-nav-item',
  templateUrl: './sidebar-nav-item.component.html',
  animations: [heightExpansion],
  standalone: false,
})
export class SidebarNavItemComponent {
  @HostBinding('class') styles = 'w-full text-gray-700 font-semibold select-none';

  showIcon = false;

  @Input() config?: SideBarNavItem;
  @Input() open = false;
  // When true the nav renders in its compact, icon-first layout
  @Input() collapsed = false;

  @Output() toggled = new EventEmitter<boolean>();
  @Output() clicked = new EventEmitter<void>();

  linkHover = false;

  protected click() {
    if (this.collapsed && this.config?.children?.length) return;

    this.clicked.emit();

    if (this.config?.children?.length) {
      this.open = !this.open;
      this.toggled.emit(this.open);
    }
  }
}
